import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import ForumTwoToneIcon from "@mui/icons-material/ForumTwoTone";
import styles from "./styles.module.css";
import { useContext, useEffect, useState } from "react";
import SnackBar from "../SnackBar";
import {
  buscaConversa,
  enviaMsg,
} from "../../services/api-planejamento-tributario.service";
import { LoginContext } from "../../config/Context/LoginContext";
import UiChat from "./UiChat";
import SendMsg from "./SendMsg";
import Loading from "../Loading";
import { enviarNotificacao } from "../../utils/webSocket.util";

const ChatAssincrono = ({
  handleOpen,
  handleCLose,
  idInteracao,
  idUsuario,
}) => {
  const { dadosLogin } = useContext(LoginContext);

  const [objSnackBar, setObjSnackBar] = useState({ type: "", msg: "" });
  const [data, setData] = useState({ idChat: null, msgs: [] });

  const [contentMsg, setContentMsg] = useState({
    value: "",
    error: null,
    helperText: "",
    renderButton: false,
  });

  const [openSendMsg, setOpenSendMsg] = useState(false);
  const [loading, setLoading] = useState(false);
  const [headerChatMsg, setHeaderChatMsg] = useState("");

  const translateUserType = (type) => {
    switch (type) {
      case "I":
        return "Interno";
      case "A":
        return "Associado";
      case "P":
        return "Parceiro";
      case "C":
        return "Cliente";
      default:
        return "error";
    }
  };

  const handleSubmit = async () => {
    try {
      if (contentMsg.value) {
        setLoading(true);

        if (contentMsg.value.length > 2000) {
          setLoading(false);
          setObjSnackBar({
            type: "error",
            msg: "O campo de mensagem excedeu o limite de caracteres.",
          });
          return;
        }

        const body = {
          ...(data.idChat && { idChat: data.idChat }),
          codGrupoUsario: idInteracao,
          msg: contentMsg.value,
          tipoContato:
            dadosLogin.tipoCadastroPlanTribKey === "I"
              ? "usuario_interno"
              : "usuario_externo",
        };

        const response = await enviaMsg(body);

        let notificacao = {};

        if (response.novaMsg.tipoContato !== "usuario_interno") {
          notificacao = {
            titulo: "Novo contato recebido!",
            texto: `Menssagem: ${response.novaMsg.msg}`,
            grupos: ["JURIDICO"],
            path: `/juridico/proponentes/?contact=${
              response.novaMsg.idUsuario
            }&type=${translateUserType(dadosLogin.tipoCadastroPlanTribKey)}`,
            tipo: "WARNING",
          };
        } else {
          notificacao = {
            titulo: "Novo contato recebido!",
            texto: `Menssagem: ${response.novaMsg.msg}`,
            usuarios: idUsuario,
            path: `/?contact=true`,
            tipo: "WARNING",
          };
        }

        await enviarNotificacao(notificacao);

        const newMsg = {
          msg: response?.novaMsg.msg,
          nome: response?.novaMsg.nome,
          tipoContato: response?.novaMsg.tipoContato,
          createdAt: response?.novaMsg.createdAt,
        };

        const bodyNewMsg = {
          ...data,
          msgs: [...(data?.msgs || []), newMsg],
        };

        setData(bodyNewMsg);

        await renderComponent(
          dadosLogin.tipoCadastroPlanTribKey === "I"
            ? "usu-int-with-msg"
            : "usu-ext-with-msg",
          response.novaMsg.tipoContato
        );

        setLoading(false);
      } else {
        setContentMsg({
          ...contentMsg,
          error: true,
          helperText: "Nenhuma mensgaem foi inserida",
        });

        setObjSnackBar({
          type: "error",
          msg: "O campo de mensagem está em branco.",
        });
      }
    } catch (error) {
      setLoading(false);

      setObjSnackBar({
        type: "error",
        msg: error.response.data.mensagem,
      });
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;

    if (value.length > 2000) {
      setObjSnackBar({
        type: "error",
        msg: "O campo de mensagem excedeu o limite de caracteres.",
      });
    } else {
      setContentMsg({
        ...contentMsg,
        value,
        ...(!value
          ? {
              error: true,
              helperText: "Nenhuma mensgaem foi inserida",
            }
          : {
              error: value.length > 2000 ? true : null,
              helperText:
                value.length > 2000
                  ? "Sua mensagem ultrapassou o limite de caracteres"
                  : `Caracteres restantes: ${2000 - value.length}`,
            }),
      });
    }
  };

  const renderComponent = async (value, typeLastMsg) => {
    switch (value) {
      case "usu-ext-not-msg":
        setContentMsg({ ...contentMsg, renderButton: true });
        setOpenSendMsg(true);
        break;
      case "usu-int-not-msg":
        setContentMsg({ ...contentMsg, renderButton: false });
        setOpenSendMsg(false);
        break;
      case "usu-ext-with-msg":
        if (typeLastMsg === "usuario_interno") {
          setContentMsg({ ...contentMsg, renderButton: true });
          setOpenSendMsg(false);
          setHeaderChatMsg("Envie uma mensagem ao destinatário da conversa");
        } else {
          setContentMsg({ ...contentMsg, renderButton: false });
          setOpenSendMsg(false);
          setHeaderChatMsg(
            "Sua resposta foi enviada ao destinatário. Ele receberá um e-mail de alerta."
          );
        }
        break;
      case "usu-int-with-msg":
        if (typeLastMsg === "usuario_externo") {
          setContentMsg({ ...contentMsg, renderButton: true });
          setOpenSendMsg(false);
          setHeaderChatMsg("Envie uma mensagem ao destinatário da conversa");
        } else {
          setOpenSendMsg(false);
          setContentMsg({ ...contentMsg, renderButton: false });
          setHeaderChatMsg(
            "Sua resposta foi enviada ao destinatário. Ele receberá um e-mail de alerta."
          );
        }
        break;

      default:
        setHeaderChatMsg("Erro ao carregar mensagens");
        setOpenSendMsg(false);
        break;
    }
  };

  useEffect(() => {
    const getData = async () => {
      try {
        let response;

        if (idUsuario) {
          response = await buscaConversa(idInteracao, idUsuario);
        } else {
          response = await buscaConversa(idInteracao);
        }

        setData({ idChat: response.idChat, msgs: response.objConversaUsuario });

        const typeLastMsg = response.objConversaUsuario.at(-1).tipoContato;

        if (response.objConversaUsuario.length > 0) {
          if (dadosLogin.tipoCadastroPlanTribKey === "I") {
            renderComponent("usu-int-with-msg", typeLastMsg);
          } else {
            renderComponent("usu-ext-with-msg", typeLastMsg);
          }
        } else {
          if (dadosLogin.tipoCadastroPlanTribKey === "I") {
            renderComponent("usu-int-not-msg");
          } else {
            renderComponent("usu-ext-not-msg");
          }
        }
      } catch (error) {
        if (
          error.status === 404 &&
          !(dadosLogin.tipoCadastroPlanTribKey === "I")
        ) {
          renderComponent("usu-ext-not-msg");
        } else if (
          error.status === 404 &&
          dadosLogin.tipoCadastroPlanTribKey === "I"
        ) {
          renderComponent("usu-int-not-msg");
        } else {
          renderComponent("error");
          setObjSnackBar({ type: "error", msg: error.response.data.mensagem });
        }
      }
    };

    if (handleOpen === true) {
      getData();
    }
  }, [handleOpen]);

  const handleSnackBar = (obj) => {
    setObjSnackBar(obj);
  };

  return (
    <>
      <Dialog
        open={handleOpen}
        onClose={() => handleCLose(false)}
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle>
          <div className={styles.title}>
            <ForumTwoToneIcon fontSize="1rem" />
            Dúvidas
          </div>
        </DialogTitle>
        <DialogContent sx={{ padding: "20px" }}>
          <>
            {loading ? (
              <Loading loading={loading} />
            ) : (
              <>
                <UiChat
                  data={data.msgs}
                  tipoUsuario={dadosLogin.tipoCadastroPlanTribKey}
                  infoText={headerChatMsg}
                  onSubmit={handleSubmit}
                />

                <SendMsg
                  contentMsg={contentMsg}
                  onChange={handleChange}
                  onSubmit={handleSubmit}
                  open={openSendMsg}
                  setOpen={(value) => setOpenSendMsg(value)}
                  loading={loading}
                  onCloseModal={() => handleCLose(false)}
                />
              </>
            )}
          </>
        </DialogContent>
      </Dialog>

      <SnackBar objSnackBar={objSnackBar} setObjSnackBar={handleSnackBar} />
    </>
  );
};

export default ChatAssincrono;
